import { request } from "@/utils/request";

/**
 * 获取当前用户可见的角色列表
 * @param {*} params 
 * @returns 
 */
export function getRoleList(params) {
  return request({
    url: '/system/role/list',
    method: 'get',
    params
  })
}

/**
 * 保存角色信息
 * @param {*} data 
 * @returns 
 */
export function saveRole(data) {
  return request({
    url: '/system/role/save',
    method: 'post',
    data
  })
}

/**
 * 删除角色信息
 * @param {*} data 
 * @returns 
 */
export function removeRole(data) {
  return request({
    url: '/system/role/remove',
    method: 'post',
    data
  })
}

/**
 * 保存角色菜单信息
 * @param {*} data 
 * @returns 
 */
export function saveRoleMenus(data) {
  return request({
    url: '/system/role/saveMenus',
    method: 'post',
    data
  })
}